import { apiSlice } from '../../api/slice'

export const roadmapSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllRoadmapItems: builder.query({
      query: () => ({
        url: `/roadmap/all`,
        method: 'GET',
      }),
    }),
  }),
})

export const { useGetAllRoadmapItemsQuery } = roadmapSlice
